import { render, staticRenderFns } from "./receivableClaim.vue?vue&type=template&id=311b556a&scoped=true"
import script from "./receivableClaim.vue?vue&type=script&lang=js"
export * from "./receivableClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311b556a",
  null
  
)

export default component.exports